// Anton: string with a dot followed by at least 2 characters and preceded by at least one
// good enough(tm) to identify url with or without protocol
export default /[a-z0-9-]\.[a-z0-9-]{2,}/;

